export const initialState: any = {
  authResolved: false,
  userFullInfo: {
    age: "",
    displayName: "",
    email: "",
    emailVerified: false,
    isAnonymous: false,
    location: "",
    metadata: {
      creationTime: "",
      lastSignInTime: ""
    },
    phoneNumber: "",
    photoURL: "",
    photoURLSecond: "",
    photoURLThird: "",
    providerData: [
      {
        displayName: "",
        photoURL: "",
        providerId: "",
        uid: ""
      }
    ],
    providerId: "",
    refreshToken: "",
    sex: "",
    tenantId: "",
    twitterUrl: "",
    uid: "",
    userID: ""
  },
  user: {
    displayName: "",
    email: "",
    emailVerified: false,
    isAnonymous: false,
    metadata: { creationTime: 0, lastSignInTime: 0 },
    phoneNumber: "",
    photoURL: "",
    photoURLSecond: "",
    photoURLThird: "",
    providerData: [[{}]],
    providerId: "",
    refreshToken: "",
    tenantId: "",
    uid: ""
  },
  userAdditionalInfo: {
    age: "",
    sex: "",
    location: ""
  },
  isLoggedIn: false,
  toBeUser: false,
  initializeSearchParams: false,
  prevRoute: "",
  unreadCount: 0,
  fcmToken: null
};
